<template>
  <div v-if="false" class="pwa">
    <div class="pwa-inner">
      <div class="pwa-right">
        <div class="btn btn-pwa" ref="pwa" @click="clickCallback">התקן</div>
      </div>
      <div class="pwa-left">
        <div class="pwa-title">התקנת האפליקציה</div>
        <div class="pwa-description">
          התקנת האפליקציה במכשיר תאפשר גישה מהירה ונוחה יותר למערכת סמארט קמפוס.
        </div>
      </div>
      <div class="close" @click.prevent="hidePwa">
        <icon name="close-modal" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Pwa',
  data() {
    return {
      deferredPrompt: null
    };
  },
  mounted() {
    this.captureEvent();
  },
  methods: {
    ...mapMutations({
      hidePwa: 'settings/HIDE_PWA'
    }),
    captureEvent() {
      window.addEventListener('beforeInstallPrompt', e => {
        // ! Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
      });
    },
    clickCallback() {
      if (this.deferredPrompt) {
        // Show the prompt
        this.deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        this.deferredPrompt.userChoice.then(choiceResult => {
          if (choiceResult.outcome === 'accepted') {
            // Call another function?
          }
          this.deferredPrompt = null;
        });
      }
    }
  }
};
</script>
